<template>
    <div style="width: 100vw; height: 100vh;">
        <div id="streamPlayer" style="width:100%;height:100%;"></div>
    </div>
</template>

<script>

    import { EventBus } from '../../utils/events';
    import * as Config from '../../config'
    import Clappr from 'clappr';

	export default {
		name: 'Chasers',
		data () {
			return {
                chaserId: null,
			}
        },
        mounted() {
            window.document.title = this.$route.query.name + "'s Stream Player"
            this.chaserId = this.$route.params.chaserId
            this.initVid()
        },
        methods: {
            initVid() {
                var playerElement = document.getElementById('streamPlayer')

                this.player = new Clappr.Player({
                    source: "https://edge-media.livestormchasing.com/hls/" + this.chaserId + "/index.m3u8",
                    autoPlay: true,
                    width: "100%",
                    height: "100%",
                    mute: true,
                })

                this.player.attachTo(playerElement)
            }
        }
	}
</script>

<style scoped>

</style>
